import "@fancyapps/fancybox/dist/jquery.fancybox.min.css";

import fancybox from "@fancyapps/fancybox/dist/jquery.fancybox.min.js";
global.fancybox = fancybox;